<template>
  <div class="header">
    <div class="logo">
      <div class="item-img" @click="linkOver(6)">
        <img :src=imgBag.logo width="395px" height="58px" alt="联盟logo">
      </div>
      <div class="item_subs">
        <div class="item-sub" v-for="(item,index) in headArr" :key="index">
          <div @click="linkOver(index)">{{item.itemName}}</div>
          <div v-show="item.isPlay" class="h_high_line">
            <img :src="imgBag.activeLine" width="85" height="7" class="tips_line">
          </div>
        </div>
        <div class="item-sub" @mouseenter="knowMEvent(1)" @mouseleave="knowMEvent(2)">
          <div @click="linkOver(5)">知识共享</div>
          <div v-if="isKnowShow" class="h_know_son">
            <know-module></know-module>
            <!-- <know-module @ctlHighLine='ctlHighLine'></know-module> -->
          </div>
          <div v-show="isKnow" class="h_high_line">
            <img :src="imgBag.activeLine" width="85" height="7" class="tips_line">
          </div>
        </div>
        <!-- <div class="item-sub" @click="gotoAdmin" v-if="localStorage.get('token')">
          <div>后台管理</div>
          <div class="h_high_line">
            <img :src="imgBag.activeLine" width="85" height="7" class="tips_line">
          </div>
        </div> -->
      </div>
      <!-- <div class="item-login">
        <div id="loginBtn" @click="loginShow">
          <img :src=imgBag.userIcon width="28" height="28" alt="">
        </div>
        <div v-show="isLogin" class="login-module">
          <global-login></global-login>
        </div>
      </div> -->
      <!-- <div class="item-find">
        <div @click="isFind = !isFind" id="findIcon">
          <img v-show="!isFind" :src=imgBag.findIcon  width="26px" height="26px" alt="">
        </div>
        <div class="find_sub" v-show="isFind">
          <home-find @findBack="isFind = false"></home-find>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import globalLogin from './login';
// import homeFind from './search';
import knowModule from './knowledge';
import { mapMutations } from 'vuex';
import * as mutationsType from '@/store/mutations/type';
import * as gettersType from '@/store/getters/type';
import { localStorage } from '@/common/util/storage';
import IMGGROUPS from '@/common/util/imgBus';
export default {
  components: {
    // globalLogin,
    // homeFind,
    knowModule
  },
  data() {
    return {
      imgBag: {
        activeLine: IMGGROUPS.activeLine,
        logo: IMGGROUPS.logo,
        findIcon: IMGGROUPS.findIcon,
        userIcon: IMGGROUPS.userIcon
      },
      isKnowShow: false,
      adminSign: false,
      localStorage,
      gettersType,
      trendPlay: false,
      knowledgePlay: false,
      isFind: false,
      isLogin: false,
      keyFindWord: '',
      activeIndex: '1',
      isKnow: false,
      headArr: [
        { itemName: '联盟简介', isPlay: false },
        { itemName: '行业要闻', isPlay: false },
        { itemName: '产品展示', isPlay: false },
        { itemName: '联盟活动', isPlay: false },
        { itemName: '联盟会员', isPlay: false }
      ]
    };
  },
  methods: {
    gotoAdmin() {
      this.$router.push({
        path: '/admin'
      });
    },
    ...mapMutations({
      setUserInfo: mutationsType.SET_USER_INFO
    }),
    linkOver(num) {
      if (num === 5) {
        this.isKnow = true;
        this.headArr.forEach(element => {
          element.isPlay = false;
        });
      } else {
        this.isKnow = false;
        this.headArr.forEach((element, index) => {
          if (index === num) element.isPlay = true;
          else element.isPlay = false;
        });
      }
      var routerName = '';
      switch (parseInt(num)) {
        case 0:
          routerName = 'overview';
          break;
        case 1:
          routerName = 'news';
          break;
        case 2:
          routerName = 'product';
          break;
        case 3:
          routerName = 'activity';
          break;
        case 4:
          routerName = 'members';
          break;
        case 5:
          routerName = 'doctorSpace';
          break;
        case 6:
          routerName = 'home';
          break;
      }
      this.$router.push({ name: routerName });
    },
    loginShow() {
      this.isLogin = !this.isLogin;
      this.isFind = false;
    },
    knowMEvent(knowNo) {
      if (knowNo === 1) {
        this.isKnowShow = true;
      } else {
        this.isKnowShow = false;
      }
    }
  },
  created() {}
};
</script>
<style scoped>
.header {
  background-color: #fff;
  height: 80px;
  line-height: 80px;
  position: relative;
  top: 0;
  left: 0;
  z-index: 60;
}
.logo {
  width: 85%;
  height: 100%;
  margin: 0 auto;
  display: -webkit-flex; /* Safari */
  display: flex;
}
.item-img {
  cursor: pointer;
  width: 30%;
  min-width: 395px;
}
.item_subs {
  width: 60%;
  display: -webkit-flex; /* Safari */
  display: flex;
}
.item-login {
  width: 10%;
  cursor: pointer;
  width: 100px;
  font-size: 16px !important;
}
.item-sub {
  height: 100%;
  width: 110px;
  text-align: center;
  font-size: 20px !important;
}
.item-sub:hover {
  cursor: pointer;
  color: #713d7b;
}

.item-find {
  float: left;
  width: 50px;
  margin-left: 225px;
  height: 100%;
  cursor: pointer;
  text-align: center;
  font-size: 20px !important;
}
.find_sub {
  position: absolute;
  top: 15px;
  margin-left: -226px;
}

.login-module {
  position: absolute;
  top: 75px;
  margin-left: -120px;
  z-index: 90;
  width: 400px;
}
.h_active_line {
  margin-left: 17.5px;
  margin-top: -20px;
  display: none;
}
.h_know_son {
  position: absolute;
  top: 60px;
  z-index: 16;
}
.h_high_line {
  margin-top: -20px;
}
.tips_line {
  margin-top: -80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/header/header.vue